import type { FC } from "react";

interface AdvantageIconProps {
  className?: string;
}

export const AdvantageIcon: FC<AdvantageIconProps> = ({ className }) => (
  <svg viewBox="0 0 48 48" className={className}>
    <g>
      <polygon fill="#fff" points="33 6 38 36 10 36 16 6" />
      <polygon fill="#2C9400" points="24 14 28 26 20 26 24 14" />
      <path
        fill="#2C9400"
        d="M44.39,12.1,23.89.39,3.5,12.29,3.61,35.9l20.5,11.71L44.5,35.71ZM31,36l-2-6H19l-2,6H10L21,8h6L38,36Z"
      />
    </g>
  </svg>
);
